var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-subheader kt-grid__item",attrs:{"id":"kt_subheader"}},[_c('div',{staticClass:"kt-container",class:{ 'kt-container--fluid': _vm.widthFluid }},[_c('div',{staticClass:"kt-subheader__main"},[_c('h3',{staticClass:"kt-subheader__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }